import ApiService from '../../../../../services/ApiService'
import GeneralService from '../../../../../services/GeneralService'
import AboutEquipment from '../AboutEquipment.vue'
import Utils from '../../../../../Utils/FormatDate'
import AboutContract from '../../../Contracts/components/AboutContract.vue'
import SetContractEquipment from '../setContractEquipment/setContractEquipment.vue'
import AddScheduleEquipment from '../addScheduleEquipment/addScheduleEquipment.vue'
import InspectionRoutineDialog from '../InspectionRoutineDialog'
import AlienateMultipleDialog from '../alienateMultipleDialog'
import DisalienateMultipleDialog from '../disalienateMultipleDialog'
import Transfer from '../transfer.vue'
import CustomizeQR from '../customizeQR.vue'

import moment from 'moment'

export default {
  data: () => ({
    ifcModal: false,
    routineSolicitationDate: null,
    routineOSKey: false,
    equipSearch: '',
    search: '',
    withoutOsCalibEnd: '',
    withoutOsCalibStart: '',
    withoutOsEletricEnd: ``,
    withoutOsEletricStart: '',
    equipmentSupplier: null,
    supplier: null,
    withoutOsValidEnd: '',
    withoutOsValidStart: '',
    expanded: [],
    totalItensOnPage: 0,
    errorMessage: '',
    excelExport: false,
    menuWarrantyStartDate: false,
    menuWarrantyEndDate: false,
    menuRegisterDateInitial: false,
    menuRegisterDateFinal: false,
    menuBuyInitialDate: false,
    menuAlienatedDateInitial: false,
    menuAlienatedDateFinal: false,
    menuLessPreventiveDateInitial: false,
    menuLessPreventiveDateFinal: false,
    filterVisible: false,
    aboutDialog: false,
    aboutContractDialog: false,
    dialogKey: false,
    loading: false,
    unidadeLoading: false,
    departmentLoading: false,
    standardEquipmentLoading: false,
    contractLoading: false,
    setContractDialog: false,
    printDialog: false,
    scheduleDialog: false,
    error: false,
    warrantyStartDate: null,
    warrantyEndDate: null,
    warrantyMinDate: null,
    registerDateInitial: null,
    registerDateFinal: null,
    registerMinDate: null,
    buyInitialDate: null,
    alienatedDateInitial: null,
    buyFinalDate: null,
    alienatedDateFinal: null,
    lessPreventiveDateInitial: null,
    lessPreventiveDateFinal: null,
    lessPreventiveMinDate: null,
    lessAlienatedMinDate: null,
    workshopType: null,
    institutionId: null,
    institutions: [],
    unidadeId: 0,
    unidades: [],
    departmentId: 0,
    departments: [],
    contractId: 0,
    contracts: [],
    standardEquipmentId: null,
    standardEquipment: [],
    currentContract: {},
    equipmentSelected: [],
    equipment: [],
    currentEquipment: {},
    userLogged: {},
    group: null,
    situations: [
      'Aluguel',
      'Comodato',
      'De médico/Equipe',
      'Empréstimo',
      'Próprio',
      'Terceiros',
      'Convênio',
      'Doação',
    ],
    alienated: ['Não', 'Sim'],
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    totalItems: 0,
    apiService: new ApiService(),
    generalService: new GeneralService(),
    filter: {
      unidadeIds: [],
      departmentIds: [],
      subDepartmentIds: [],
      page: 1,
      pageSize: 10,
      name: null,
      model: null,
      serialNumber: null,
      criticalityMin: 0,
      criticalityMax: 0,
      departmentId: 0,
      contractId: 0,
      registerDateInitial: null,
      registerDateFinal: null,
      institutionId: null,
      unidadeId: 0,
      warrantyStartDate: null,
      warrantyEndDate: null,
      lessPreventiveInitialDate: null,
      lessPreventiveFinalDate: null,
      alienated: false,
      situation: null,
      identification: null,
      manufacturer: null,
      supplierId: null,
      propertyCode: null,
      numberAnvisa: null,
      standardEquipmentId: null,
      ordination: null,
      subDepartmentIds: [],
      costCenterIds: [],
      equipmentIds: [],
      withoutOsCalibStart: null,
      withoutOsCalibEnd: null,
      withoutOsEletricStart: null,
      withoutOsEletricEnd: null,
      withoutOsValidStart: null,
      withoutOsValidEnd: null,
    },
    equipmentName: null,
    equipmentModel: null,
    equipmentSerialNumber: null,
    equipmentDepartmentId: 0,
    equipmentCriticalityMin: null,
    equipmentCriticalityMax: null,
    equipmentContractId: 0,
    equipmentRegisterDateInitial: null,
    equipmentRegisterDateFinal: null,
    equipmentUnidadeId: 0,
    equipmentWarrantyStartDate: null,
    equipmentWarrantyEndDate: null,
    equipmentBuyInitialDate: null,
    equipmentAlienatedDateInitial: null,
    equipmentBuyFinalDate: null,
    equipmentAlienatedDateFinal: null,
    equipmentLessPreventiveDateInitial: null,
    equipmentLessPreventiveDateFinal: null,
    equipmentAlienated: 'Não',
    equipmentSituation: null,
    equipmentIdentification: null,
    equipmentManufacturer: null,
    equipmentPropertyCode: null,
    equipmentNumberAnvisa: null,
    location: '',
    headMenu: false,
    headers: [
      {
        text: 'Número de Série',
        align: 'center',
        value: 'serialNumber',
        active: false,
        width: 180,
      },
      {
        text: 'Equip. ID',
        align: 'center',
        value: 'identification',
        active: true,
        width: 180,
      },
      {
        text: 'Equipamento',
        align: 'center',
        value: 'name',
        active: true,
      },
      {
        text: 'Centro de Custo',
        align: 'center',
        value: 'costCenter.name',
        active: false,
        width: 180,
      },
      {
        text: 'Data Compra',
        align: 'center',
        value: 'purchaseDate',
        active: false,
        width: 180,
      },
      {
        text: 'Unidade',
        align: 'center',
        value: 'unidade.name',
        active: false,
        width: 180,
      },
      {
        text: 'Setor',
        align: 'center',
        value: 'department.name',
        active: false,
        width: 180,
      },
      {
        text: 'Sub-Setor',
        align: 'center',
        value: 'subDepartment.name',
        active: false,
        width: 180,
      },
      {
        text: 'Situação',
        align: 'center',
        value: 'equipmentAcquisitionSituation',
        active: false,
        width: 180,
      },
      {
        text: 'Fabricante',
        align: 'center',
        value: 'manufacturer',
        active: true,
      },
      {
        text: 'Modelo',
        align: 'center',
        value: 'model',
        active: true,
      },
      {
        text: 'Cod. Patrimônio',
        align: 'center',
        value: 'propertyCode',
        active: true,
      },
      {
        text: 'Equipamento padrão',
        align: 'center',
        value: 'standardEquipment.name',
        active: false,
        width: 180,
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
        width: 350,
        active: true,
      },
    ],
    headersMobile: [
      {
        text: 'Equip. ID',
        align: 'center',
        value: 'identification',
      },
      {
        text: 'Ações',
        value: 'actions',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    items: [
      {
        action: 'mdi-ticket',
        items: [{ title: 'List Item' }],
        title: 'Attractions',
      },
      {
        action: 'mdi-silverware-fork-knife',
        active: true,
        items: [
          { title: 'Breakfast & brunch' },
          { title: 'New American' },
          { title: 'Sushi' },
        ],
        title: 'Dining',
      },
    ],
    exportMenu: [
      {
        icon: 'mdi-microsoft-excel',
        title: 'Excel',
        action: 'excel',
        access: [0, 1, 2, 3, 4, 5, 7, 8],
      },
      {
        icon: 'mdi-file-code-outline',
        title: 'HTML',
        action: 'html',
        access: [0, 1, 2, 3, 4, 5, 7, 8],
      },
      {
        icon: 'mdi-qrcode',
        title: 'QRCode',
        options: [
          {
            title: 'Customizar QRCODE',
            action: 'qrcode-customize',
            icon: 'mdi-circle-edit-outline',
          },
          {
            title: 'QRCode Etiqueta',
            action: 'qrcode',
            icon: 'mdi-ticket',
          },
          {
            title: 'QRCode Excel',
            action: 'qrcodeXlsx',
            icon: 'mdi-microsoft-excel',
          },
        ],
        access: [0, 1, 2, 3, 8],
      },
    ],
    sendSelectindMenu: [
      {
        icon: 'mdi-clock-time-ten-outline',
        title: 'Cronograma',
        action: 'schedule',
      },
      {
        icon: 'mdi-file-document-multiple-outline',
        title: 'Contrato',
        action: 'contract',
      },
      {
        icon: 'mdi-file-document',
        title: 'Template de Rotina de inspeção',
        action: 'inspectionRoutine',
      },
      {
        icon: 'mdi-book-open-outline',
        title: 'Abrir OS de Rotina de inspeção',
        action: 'inspectionRoutineOS',
      },
      {
        icon: 'mdi-transfer',
        title: 'Transferência Equipamentos',
        action: 'transfer',
      },
      {
        icon: 'mdi-close-box-multiple-outline',
        title: 'Alienar',
        action: 'alienate',
      },
      {
        icon: 'mdi-checkbox-multiple-marked-outline',
        title: 'Desalienar',
        action: 'disalienate',
      },
      {
        icon: 'mdi-pencil-outline',
        title: 'Editar multiplos',
        action: 'editMultiples',
      },
    ],
    newEquipmentMenu: [
      {
        icon: 'mdi-plus-box-outline',
        title: 'Adicionar equipamento',
        action: 'addEquipment',
      },
      {
        icon: 'mdi-plus-box-multiple-outline',
        title: 'Adicionar múltiplos equipamentos',
        action: 'addMultiples',
      },
    ],
    manufacturers: [],
    manufLoading: false,
    inspDialogKey: false,
    inspDialog: false,
    alienateMultipleDialog: false,
    alienateMultipleDialogKey: false,
    disalienateMultipleDialog: false,
    disalienateMultipleDialogKey: false,
    equipmentsToAlienate: [],
    equipmentsToDisalienate: [],
    localDepartments: [],
    menuLoading: false,
    subSectorSearch: '',
    costCenterSearch: '',
    transferDialog: false,
    transferDialogKey: false,
    customizeDialog: false,
    routineOSDialog: false,
    unitSearch: null,
    unidadeIds: [],
    costCenter: [],
    costCenterLoading: false,
  }),

  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = this.institution.id
    this.workshopType = this.institution.workshopType

    await this.getInstitutions()

    if (this.institution.userType > 1) {
      await this.getUserUnidades()
    } else {
      await this.getUnidades()
    }

    await this.getDepartments()
    await this.getContracts()
    await this.getStandardEquipment()
    await this.getManufacturers()
    await this.getSuppliers()
    await this.getCostCenters() // Carrega todos os centros de custo inicialmente

    await this.updateTable()

    if (this.userLogged.equipColumns) {
      const columns = JSON.parse(this.userLogged.equipColumns)
      this.headers = columns ? columns : this.headers
    }
  },

  components: {
    CustomizeQR,
    AlienateMultipleDialog,
    DisalienateMultipleDialog,
    InspectionRoutineDialog,
    AboutEquipment,
    AboutContract,
    SetContractEquipment,
    AddScheduleEquipment,
    Transfer,
  },

  computed: {
    subDepartments() {
      const departments = this.localDepartments.filter(
        (x) =>
          this.filter.departmentIds && this.filter.departmentIds.includes(x.id)
      )

      return departments.map((x) => x.subDepartments).flat(1)
    },
    filteredDepartments() {
      if (!this.filter.unidadeIds || this.filter.unidadeIds.length === 0) {
        return this.localDepartments
      }

      return this.localDepartments.filter((department) =>
        this.filter.unidadeIds.includes(department.unidade.id)
      )
    },
  },

  methods: {
    setRoutineSolicitationNowDate() {
      this.routineSolicitationDate = !this.routineSolicitationDate
        ? new Date()
        : this.routineSolicitationDate
    },

    removeStandardEquipment(item) {
      this.filter.standardEquipmentIds.splice(item, 1)
      this.filter.standardEquipmentIds = [...this.filter.standardEquipmentIds]
    },
    removeDepartment(item) {
      this.filter.departmentIds.splice(item, 1)
      this.filter.departmentIds = [...this.filter.departmentIds]
    },
    removeCostCenter(item) {
      this.filter.costCenterIds.splice(item, 1)
      this.filter.costCenterIds = [...this.filter.costCenterIds]
    },
    removeSubDepartment(item) {
      this.filter.subDepartmentIds.splice(item, 1)
      this.filter.subDepartmentIds = [...this.filter.subDepartmentIds]
    },
    removeUnit(item) {
      this.filter.unidadeIds.splice(this.filter.unidadeIds.indexOf(item.id), 1)
      this.filter.unidadeIds = [...this.filter.unidadeIds]
    },
    updateHeaders() {
      this.menuLoading = true

      const json = JSON.stringify(this.headers)
      this.apiService
        .post('user/saveColumns/equip', { columns: json })
        .then(() => {
          let userLogged = JSON.parse(localStorage.getItem('user'))
          userLogged.equipColumns = json
          this.headMenu = false
          localStorage.setItem('user', JSON.stringify(userLogged))
          this.$toast.success(this.$t('Configuração salva no seu usuário!'))
          this.menuLoading = false
        })
        .catch(() => {
          this.menuLoading = false
        })
    },

    confirmAlienation() {
      this.alienateMultipleDialog = false
      this.alienateMultipleDialogKey = !this.alienateMultipleDialogKey
      this.equipmentSelected = []
      this.updateTable()
    },

    getManufacturers() {
      this.manufLoading = true
      this.apiService
        .get(`manufacturer/list/${this.institutionId}`)
        .then((response) => {
          this.manufacturers = response.content
          this.manufLoading = false
        })
        .catch(() => {
          this.manufLoading = false
        })
    },

    getSuppliers() {
      this.apiService
        .get(`supplier/list/${this.institutionId}`)
        .then((response) => {
          this.supplier = response.content
        })
        .catch(() => {})
    },

    addEquipment() {
      this.$router.push('/newEquipment')
    },

    addMultiples() {
      this.$router.push('/multiplesEquipment')
    },
    editMultiples() {
      const equipList = this.equipmentSelected.map((x) => x.id)

      if (equipList.length > 30) {
        this.$toast.error('Máximo de 30 equipamentos por vez')
        return
      }
      this.$router.push(`/editMultiplesEquipment?id=${equipList.join()}`)
    },

    editEquipment(equipment) {
      if (this.institution.userType > 3 && this.institution.userType != 8)
        return
      this.currentEquipment = equipment
      const route = this.$router.resolve({
        path: `/editEquipment/${this.currentEquipment.id}`,
      })
      window.open(route.href, '_blank')
    },

    setContract() {
      this.setContractDialog = true
      this.dialogKey = !this.dialogKey
    },

    addSchedule() {
      this.scheduleDialog = true
      this.dialogKey = !this.dialogKey
    },

    openSchedule() {
      this.$router.push('chronogram')
    },

    isInactive(value) {
      return value.department.status == 1 ? 'departmentInactive' : ''
    },

    menuChildExport(action) {
      switch (action) {
        case 'qrcode-customize':
          this.openCustomizeQR()
          break
        case 'qrcode':
          this.openExportQrCode()
          break
        case 'qrcodeXlsx':
          this.gerenarateQrCodeExcel()
          break
      }
    },

    openCustomizeQR() {
      this.customizeDialog = true
    },

    menuExportActionClick(action) {
      switch (action) {
        case 'excel':
          this.generateExcel()
          break
        case 'html':
          this.generateHtml()
          break
        case 'qrcode':
          this.openExportQrCode()
          break
        case 'qrcodeXlsx':
          this.gerenarateQrCodeExcel()
          break
      }
    },

    menuSendSelecionActionClick(action) {
      switch (action) {
        case 'schedule':
          this.addSchedule()
          break
        case 'contract':
          this.setContract()
          break
        case 'inspectionRoutine':
          this.setInspectionRoutine()
          break
        case 'inspectionRoutineOS':
          this.routineSolicitationDate = null
          this.routineOSKey = !this.routineOSKey
          this.routineOSDialog = true
          break
        case 'transfer':
          this.transferEquipments()
          break
        case 'alienate':
          this.alienateMultiple()
          break
        case 'disalienate':
          this.disalienateMultiple()
          break
        case 'editMultiples':
          this.editMultiples()
          break
      }
    },

    openRoutineOSsToEquipList() {
      if (!this.routineSolicitationDate) {
        this.$toast.warning('Insira uma data para prosseguir!')
        return
      }

      const equipmentIds = this.equipmentSelected.map((x) => x.id)

      const model = {
        equipIds: equipmentIds,
        date: this.routineSolicitationDate,
      }

      this.apiService
        .post('inspectionRoutineChecklist/add-by-equip-list', model)
        .then((response) => {
          this.$toast.success('Ordens de serviço de inspeção abertas! 📋')
          this.equipmentSelected = []
          this.routineOSDialog = false
        })
    },

    transferEquipments() {
      this.transferDialogKey = !this.transferDialogKey
      this.transferDialog = true
    },

    setInspectionRoutine() {
      this.inspDialogKey = !this.inspDialogKey
      this.inspDialog = true
    },

    alienateMultiple() {
      // Alienar apenas os equipamentos selecionados que ainda não estão alienados.
      this.equipmentsToAlienate = this.equipmentSelected.filter(
        (x) => !x.alienated
      )

      if (this.equipmentsToAlienate.length === 0) {
        this.$toast.warning(
          'Nenhum dos equipamentos selecionados está disponível para alienação.'
        )
        return
      }

      this.alienateMultipleDialog = true
      this.alienateMultipleDialogKey = !this.alienateMultipleDialogKey
    },

    disalienateMultiple() {
      // Desalienar apenas os equipamentos selecionados que estão alienados.
      this.equipmentsToDisalienate = this.equipmentSelected.filter(
        (x) => x.alienated
      )

      if (this.equipmentsToDisalienate.length === 0) {
        this.$toast.warning(
          'Nenhum dos equipamentos selecionados está alienado.'
        )
        return
      }

      this.disalienateMultipleDialog = true
      this.disalienateMultipleDialogKey = !this.disalienateMultipleDialogKey
    },

    confirmDisalienation() {
      this.disalienateMultipleDialog = false
      this.disalienateMultipleDialogKey = !this.disalienateMultipleDialogKey
      this.equipmentSelected = []
      this.updateTable()
    },

    menuNewEquipmentActionClick(action) {
      switch (action) {
        case 'addEquipment':
          this.addEquipment()
          break
        case 'addMultiples':
          this.addMultiples()
          break
      }
    },

    openAbout(equipment) {
      this.currentEquipment = equipment
      this.dialogKey = !this.dialogKey
      this.aboutDialog = true
    },

    openExportQrCode() {
      this.filter.page = 1
      this.filter.pageSize = 0
      if (this.equipmentSelected.length > 0) {
        this.filter.equipmentIds = this.equipmentSelected.map((eq) => eq.id)
      } else {
        this.filter.equipmentIds = []
      }
      this.$router.push({
        name: 'exportQrcode',
        params: { filter: this.filter },
      })
    },

    hasAccess(val) {
      const result = val.find((type) => this.institution.userType == type)

      if (result == undefined) {
        return false
      } else {
        return true
      }
    },

    handleSortUpdate({ sortBy, sortDesc }) {
      if (sortBy[0] == 'identification') {
        if (!sortDesc[0]) {
          this.filter.ordination = 0
        } else {
          this.filter.ordination = 1
        }
        this.updateTable()
      }
    },

    async openAboutContract(contractId) {
      if (contractId != null) {
        await this.apiService
          .get(`contract/${this.institutionId}/${contractId}`)
          .then((response) => {
            this.currentContract = response.content
            this.dialogKey = !this.dialogKey
            this.aboutContractDialog = true
          })
          .catch((err) => {
            this.errorMessage = err.body.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })
      }
    },

    closeDialog() {
      this.dialog = false
      this.editDialog = false
      this.aboutDialog = false
      this.setContractDialog = false
      this.scheduleDialog = false
      this.inspDialog = false

      this.updateTable()
    },

    clearSelection() {
      this.equipmentSelected = []
    },

    uploadDocument(equipment) {
      this.currentEquipment = equipment
      sessionStorage.clear()
      sessionStorage.setItem('equipment', JSON.stringify(this.currentEquipment))

      let routeData = this.$router.resolve({ path: '/uploadDocument' })
      window.open(routeData.href, '_blank')
    },

    filterTable() {
      this.page = 1
      const {
        unidadeIds,
        departmentIds,
        subDepartmentIds,
        costCenterIds,
        equipmentIds,
        standardEquipmentIds,
        withoutOsCalibStart,
        withoutOsCalibEnd,
        withoutOsEletricStart,
        withoutOsEletricEnd,
        withoutOsValidStart,
        withoutOsValidEnd,
      } = this.filter
      this.filter = {
        page: 1,
        pageSize: this.pageSize,
        name: null,
        model: null,
        serialNumber: null,
        criticalityMin: 0,
        criticalityMax: 0,
        departmentId: 0,
        contractId: 0,
        registerDateInitial: null,
        registerDateFinal: null,
        institutionId: null,
        unidadeId: 0,
        warrantyStartDate: null,
        warrantyEndDate: null,
        lessPreventiveInitialDate: null,
        lessPreventiveFinalDate: null,
        alienated: null,
        situation: null,
        identification: null,
        manufacturer: null,
        supplierId: null,
        propertyCode: null,
        numberAnvisa: null,
        standardEquipmentId: this.standardEquipmentId,
        standardEquipmentIds: standardEquipmentIds || [],
        ordination: null,
        unidadeIds: unidadeIds || [],
        departmentIds: departmentIds || [],
        subDepartmentIds: subDepartmentIds || [],
        costCenterIds: costCenterIds || [],
        equipmentIds: equipmentIds || [],
        buyInitialDate: '',
        buyFinalDate: '',
        alienatedStartDate: '',
        alienatedEndDate: '',
        location: null,
        withoutOsCalibStart: withoutOsCalibStart || null,
        withoutOsCalibEnd: withoutOsCalibEnd || null,
        withoutOsEletricStart: withoutOsEletricStart || null,
        withoutOsEletricEnd: withoutOsEletricEnd || null,
        withoutOsValidStart: withoutOsValidStart || null,
        withoutOsValidEnd: withoutOsValidEnd || null,
      }
      this.filter.name = this.equipmentName
      this.filter.model = this.equipmentModel
      this.filter.serialNumber = this.equipmentSerialNumber
      this.filter.criticalityMin = this.equipmentCriticalityMin
        ? this.equipmentCriticalityMin
        : 0
      this.filter.criticalityMax = this.equipmentCriticalityMax
        ? this.equipmentCriticalityMax
        : 0
      this.filter.contractId = this.equipmentContractId
      this.filter.registerDateInitial = this.equipmentRegisterDateInitial
      this.filter.registerDateFinal = this.equipmentRegisterDateFinal
      this.filter.warrantyStartDate = this.equipmentWarrantyStartDate
      this.filter.warrantyEndDate = this.equipmentWarrantyEndDate
      this.filter.alienated =
        this.equipmentAlienated === 'Sim'
          ? true
          : this.equipmentAlienated === 'Não'
          ? false
          : null
      this.filter.situation = this.situations.indexOf(this.equipmentSituation)
      this.filter.identification = this.equipmentIdentification
      this.filter.manufacturer = this.equipmentManufacturer
      this.filter.supplierId = this.equipmentSupplier
      this.filter.propertyCode = this.equipmentPropertyCode
      this.filter.numberAnvisa = this.equipmentNumberAnvisa
      this.filter.lessPreventiveInitialDate =
        this.equipmentLessPreventiveDateInitial
      this.filter.lessPreventiveFinalDate =
        this.equipmentLessPreventiveDateFinal

      this.filter.buyInitialDate =
        this.equipmentBuyInitialDate != null
          ? moment(this.equipmentBuyInitialDate).format('yyyy-MM-DD')
          : ''

      this.filter.alienatedStartDate =
        this.equipmentAlienatedDateInitial != null
          ? moment(this.equipmentAlienatedDateInitial).format('yyyy-MM-DD')
          : ''

      this.filter.buyFinalDate =
        this.equipmentBuyFinalDate != null
          ? moment(this.equipmentBuyFinalDate).format('yyyy-MM-DD')
          : ''

      this.filter.alienatedEndDate =
        this.equipmentAlienatedDateFinal != null
          ? moment(this.equipmentAlienatedDateFinal).format('yyyy-MM-DD')
          : ''

      this.filter.institutionId = this.institutionId
      this.filter.unidadeId = this.unidadeId
      this.filter.location = this.location
      this.syncUnidadeIdsFromDepartments()
      if (this.filter.unidadeIds && this.filter.unidadeIds.length > 0) {
        this.filter.unidadeId = 0
      } else {
        this.filter.unidadeId = this.unidadeId
      }

      this.updateTable()
    },

    async updateTable() {
      this.loading = true

      this.filter.institutionId = this.institutionId

      await this.apiService
        .post('equipment/list', this.filter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.equipment = response.content.equipment.map((x) => {
            x.serviceOrders.sort(function (a, b) {
              return new Date(b.dateTimeRequest) - new Date(a.dateTimeRequest)
            })
            return {
              ...x,
            }
          })
          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.equipment.length
          this.loading = false
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getDepartments() {
      this.departmentLoading

      await this.apiService
        .get(`department/listActive/${this.institutionId}`)
        .then((response) => {
          this.departments = response.content
          this.localDepartments = this.departments.filter((x) =>
            this.unidades.map((x) => x.id).includes(x.unidadeId)
          )
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.departmentLoading = false
    },

    async getContracts() {
      this.contractLoading = true

      await this.apiService
        .get(`contract/list/${this.institutionId}`)
        .then((response) => {
          this.contracts = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.contractLoading = false
    },

    async getStandardEquipment() {
      this.standardEquipmentLoading = true

      this.standardEquipment =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institutionId
        )

      this.standardEquipmentLoading = false
    },
    async getCostCenters() {
      this.costCenterLoading = true

      try {
        let allCostCenters = []

        if (!this.filter.unidadeIds || this.filter.unidadeIds.length === 0) {
          // Se não há unidades selecionadas, buscar todos os centros de custo da instituição
          const response = await this.apiService.get(
            `CostCenter/listActive/${this.institutionId}`
          )
          if (response.content) {
            allCostCenters = response.content
          }
        } else {
          // Se há unidades selecionadas, buscar centros de custo para cada unidade
          for (const unidadeId of this.filter.unidadeIds) {
            const response = await this.apiService.get(
              `costCenter/listByUnidade/${this.institutionId}/${unidadeId}`
            )
            if (response.content) {
              allCostCenters = [...allCostCenters, ...response.content]
            }
          }

          // Remover duplicatas baseado no ID
          allCostCenters = allCostCenters.filter(
            (center, index, self) =>
              index === self.findIndex((c) => c.id === center.id)
          )
        }

        this.costCenter = allCostCenters
      } catch (error) {
        this.$toast.error('Erro ao buscar centros de custo')
      }

      this.costCenterLoading = false
    },

    async generateExcel() {
      this.filter.institutionId = this.institutionId
      this.filter.unidadeId = this.unidadeId
      // Se há equipamentos selecionados, incluir seus IDs no filtro
      if (this.equipmentSelected.length > 0) {
        this.filter.equipmentIds = this.equipmentSelected.map((eq) => eq.id)
      } else {
        this.filter.equipmentIds = []
      }

      this.printDialog = true
      let now = new Date()
      const fileName = `Equipamentos_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`

      try {
        const response = await this.apiService.post(
          'equipment/exportExcel',
          this.filter
        )
        this.downloadExcel(response, fileName)
      } catch (error) {
        this.$toast.error(this.$t('Erro ao exportar equipamentos'))
      } finally {
        this.printDialog = false
      }
    },

    downloadExcel(base64, fileName) {
      if (typeof base64 !== 'string' || !base64.trim()) {
        throw new Error('Arquivo Excel inválido')
      }

      const binary = atob(base64)
      const bytes = new Uint8Array(binary.length)
      for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i)
      }

      this.apiService.makeDownLoadFile(
        bytes,
        fileName,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      )
    },

    async generateHtml() {
      this.filter.institutionId = this.institutionId
      this.filter.unidadeId = this.unidadeId
      // Se há equipamentos selecionados, incluir seus IDs no filtro
      if (this.equipmentSelected.length > 0) {
        this.filter.equipmentIds = this.equipmentSelected.map((eq) => eq.id)
      } else {
        this.filter.equipmentIds = []
      }

      this.printDialog = true
      await this.apiService
        .post(`equipment/exportHtml`, this.filter)
        .then((response) => {
          var w = window.open('')
          w.document.write(response)
          this.printDialog = false
        })
    },

    async gerenarateQrCodeExcel() {
      this.filter.institutionId = this.institutionId
      this.filter.unidadeId = this.unidadeId
      // Se há equipamentos selecionados, incluir seus IDs no filtro
      if (this.equipmentSelected.length > 0) {
        this.filter.equipmentIds = this.equipmentSelected.map((eq) => eq.id)
      } else {
        this.filter.equipmentIds = []
      }

      this.printDialog = true
      const fileName = `QrCodeList.xlsx`

      const exportModel = {
        Filter: this.filter,
        Link: `${window.location.origin}/aboutEquipment/`,
      }

      try {
        const response = await this.apiService.post(
          'equipment/listQrCode',
          exportModel
        )
        this.downloadExcel(response, fileName)
      } catch (error) {
        this.$toast.error(this.$t('Erro ao exportar equipamentos'))
      } finally {
        this.printDialog = false
      }
    },

    reset() {
      if (this.institution.userType > 4 && this.institution.userType != 8) {
        this.unidadeId = this.userLogged.unidadeId
      } else {
        this.unidadeId = 0
      }
      this.withoutOsEletricStart = null
      this.withoutOsEletricEnd = null
      this.withoutOsCalibStart = null
      this.withoutOsCalibEnd = null
      this.withoutOsValidStart = null
      this.withoutOsValidEnd = null
      this.equipmentBuyFinalDate = null
      this.buyFinalDate = null
      this.warrantyStartDate = null
      this.warrantyEndDate = null
      this.registerDateInitial = null
      this.registerDateFinal = null
      this.lessPreventiveDateInitial = null
      this.lessPreventiveDateFinal = null
      this.buyInitialDate = null
      this.alienatedDateInitial = null
      this.buyFinalDate = null
      this.alienatedDateFinal = null
      this.equipmentName = null
      this.equipmentModel = null
      this.equipmentSerialNumber = null
      this.equipmentDepartmentId = 0
      this.equipmentCriticalityMin = null
      this.equipmentCriticalityMax = null
      this.equipmentContractId = 0
      this.equipmentRegisterDateInitial = null
      this.equipmentRegisterDateFinal = null
      this.equipmentWarrantyStartDate = null
      this.equipmentWarrantyEndDate = null
      this.equipmentLessPreventiveDateInitial = null
      this.equipmentLessPreventiveDateFinal = null
      this.equipmentBuyInitialDate = null
      this.equipmentAlienatedDateInitial = null
      this.equipmentAlienatedDateFinal = null
      this.equipmentAlienated = null
      this.equipmentSituation = -1
      this.equipmentIdentification = null
      this.equipmentManufacturer = null
      this.equipmentSupplier = null
      this.equipmentPropertyCode = null
      this.equipmentNumberAnvisa = null
      this.standardEquipmentId = null
      this.equipmentSelected = []
      this.filter = {
        page: 1,
        pageSize: this.pageSize,
        name: null,
        model: null,
        serialNumber: null,
        departmentId: 0,
        criticalityMin: 0,
        criticalityMax: 0,
        contractId: 0,
        registerDateInitial: null,
        registerDateFinal: null,
        unidadeId: 0,
        warrantyStartDate: null,
        warrantyEndDate: null,
        alienated: null,
        situation: null,
        identification: null,
        manufacturer: null,
        supplierId: null,
        propertyCode: null,
        numberAnvisa: null,
        standardEquipmentId: null,
        unidadeIds: [],
        departmentIds: [],
        subDepartmentIds: [],
        withoutOsCalibStart: null,
        withoutOsCalibEnd: null,
        withoutOsEletricStart: null,
        withoutOsEletricEnd: null,
        withoutOsValidStart: null,
        withoutOsValidEnd: null,
      }
      this.updateTable()
    },

    formatDate(date) {
      return date ? Utils.moment(date) : ''
    },

    parseDate(date) {
      if (!date) return date

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.warrantyStartDate = this.formatInputDate(
        this.equipmentWarrantyStartDate
      )

      this.$refs.menuWarrantyStartDate.save(date)

      this.warrantyMinDate = new Date(this.equipmentWarrantyStartDate)
        .toISOString()
        .substr(0, 10)

      this.warrantyEndDate = this.formatInputDate(this.equipmentWarrantyEndDate)

      this.$refs.menuWarrantyEndDate.save(date)

      this.registerDateInitial = this.formatInputDate(
        this.equipmentRegisterDateInitial
      )

      this.registerMinDate = new Date(this.equipmentRegisterDateInitial)
        .toISOString()
        .substr(0, 10)

      this.$refs.menuRegisterDateInitial.save(date)

      this.registerDateFinal = this.formatInputDate(
        this.equipmentRegisterDateFinal
      )

      this.$refs.menuRegisterDateFinal.save(date)

      this.lessPreventiveDateInitial = this.formatInputDate(
        this.equipmentLessPreventiveDateInitial
      )

      this.lessPreventiveMinDate = new Date(
        this.equipmentLessPreventiveDateInitial
      )
        .toISOString()
        .substr(0, 10)
      this.$refs.menuLessPreventiveDateInitial.save(date)

      this.lessPreventiveDateFinal = this.formatInputDate(
        this.equipmentLessPreventiveDateFinal
      )

      this.$refs.menuLessPreventiveDateFinal.save(date)

      this.buyInitialDate = this.formatInputDate(this.equipmentBuyInitialDate)

      this.alienatedDateInitial = this.formatInputDate(
        this.equipmentAlienatedDateInitial
      )

      this.$refs.menuBuyInitialDate.save(date)

      this.$refs.menuAlienatedDateInitial.save(date)

      this.buyFinalDate = this.formatInputDate(this.equipmentBuyFinalDate)

      this.alienatedDateFinal = this.formatInputDate(
        this.equipmentAlienatedDateFinal
      )

      this.$refs.menuBuyFinalDate.save(date)
      this.$refs.menuAlienatedDateFinal.save(date)

      this.withoutOsEletricStart = this.formatInputDate(
        this.filter.withoutOsEletricStart
      )
      this.$refs.withoutOsEletricStart.save(date)

      this.withoutOsEletricEnd = this.formatInputDate(
        this.filter.withoutOsEletricEnd
      )

      this.withoutOsValidStart = this.formatInputDate(
        this.filter.withoutOsValidStart
      )
      this.$refs.withoutOsValidStart.save(date)

      this.withoutOsValidEnd = this.formatInputDate(
        this.filter.withoutOsValidEnd
      )

      this.$refs.withoutOsCalibStart.save(date)

      this.withoutOsCalibStart = this.formatInputDate(
        this.filter.withoutOsCalibStart
      )
      this.$refs.withoutOsEletricEnd.save(date)

      this.withoutOsCalibEnd = this.formatInputDate(
        this.filter.withoutOsCalibEnd
      )
      this.$refs.withoutOsCalibEnd.save(date)
    },

    async generatePDF(equipment) {
      this.printDialog = true
      this.apiService
        .get(`equipment/printEquipment/${equipment.id}`)
        .then((response) => {
          var pedfResult = 'data:application/pdf;base64,' + response.content.pdf
          const link = document.createElement('a')
          link.href = pedfResult
          link.setAttribute(
            'download',
            `Equipamento:${equipment.id}_${this.formatDate(new Date())}`
          )
          document.body.appendChild(link)
          link.click()
          this.printDialog = false
        })
        .catch(() => {})
    },

    showSuccess(message) {
      this.$emit('show', message)
    },

    syncUnidadeIdsFromDepartments() {
    if (this.filter.unidadeIds && this.filter.unidadeIds.length > 0) return

    if (!this.filter.departmentIds || this.filter.departmentIds.length === 0) return

    const unidadeIds = this.departments
    .filter((department) => this.filter.departmentIds.includes(department.id))
    .map((department) => department.unidadeId)
    .filter((id) => id != null)

    const uniqueUnidadeIds = [...new Set(unidadeIds)]

    this.$set(this.filter, 'unidadeIds', uniqueUnidadeIds)
    }
  },

  watch: {
    'filter.unidadeIds': {
      handler() {
        if (this.filter.unidadeIds && this.filter.unidadeIds.length > 0) {
          this.localDepartments = this.departments.filter((x) =>
            this.filter.unidadeIds.includes(x.unidadeId)
          )
        } else {
          this.localDepartments = this.departments.filter((x) =>
            this.unidades.map((x) => x.id).includes(x.unidadeId)
          )
        }
        this.getCostCenters() // Sempre chama getCostCenters para atualizar a listagem
      },
      deep: true,
    },

    equipmentAlienatedDateInitial(v) {
      if (v) {
        this.equipmentAlienated = 'Sim'
      }
    },

    equipmentAlienatedDateFinal(v) {
      if (v) {
        this.equipmentAlienated = 'Sim'
      }
    },

    pageSize() {
      this.filter.pageSize = this.pageSize
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },
  },
}
